import { HandsClappingIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Clap = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <HandsClappingIcon {...rest} size={Sizes[size]} color={fill} />;
};

Clap.displayName = 'Clap';
